import React from "react";
import type { SvgIconComponent } from "@mui/icons-material";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentsIcon from "@mui/icons-material/Payments";
import PeopleIcon from "@mui/icons-material/People";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import type { TbsNavIcon } from "../../pages/tbs/shared/navigation";

// The one place a navigation area is drawn as a picture.
//
// Separate from `navigation.ts` so that module stays plain data with no React in it — it is read by
// tests that never render anything. `Record<TbsNavIcon, …>` is what makes a new area a compile
// error here rather than a blank square on the landing.

export const NAV_ICONS: Record<TbsNavIcon, SvgIconComponent> = {
  pos: PointOfSaleIcon,
  products: Inventory2Icon,
  inventory: WarehouseIcon,
  invoices: ReceiptLongIcon,
  payments: PaymentsIcon,
  contacts: PeopleIcon,
  reports: AssessmentIcon,
  config: SettingsIcon,
};

interface Props {
  icon: TbsNavIcon;
  fontSize?: "small" | "medium" | "large";
  color?: string;
}

export const NavIcon: React.FC<Props> = ({ icon, fontSize = "medium", color }) => {
  const Icon = NAV_ICONS[icon];
  return <Icon fontSize={fontSize} sx={color ? { color } : undefined} />;
};

export default NavIcon;
